import {
  BrandMark,
  hostUrl,
  LanguageSelect,
  ThemeToggle,
  Toasts,
  useAuthStore,
} from '@sentinel/web-core';
import { Button } from '@sentinel/ui';
import { Link, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleNav } from './ConsoleNav';

/** The console: brand, tools, who is signed in, sections, content, toasts. */
export function ConsoleShell() {
  const { t } = useTranslation();
  const me = useAuthStore((s) => s.me);
  const logout = useAuthStore((s) => s.logout);
  const signOut = async () => {
    await logout();
    // The `accounts.` session ends too, or the next visit would hand back in (ADR 0013).
    window.location.assign(`${hostUrl('accounts')}/logout`);
  };
  return (
    <div className="shell">
      <header className="topbar">
        <Link to="/" className="brand">
          <BrandMark size={26} />
          <span>
            <b>{t('console.brand.product')}</b>
            <i>{t('console.brand.suite')}</i>
          </span>
        </Link>
        <div className="tools">
          <LanguageSelect />
          <ThemeToggle />
          <span className="note">{me?.displayName}</span>
          <Button size="sm" onClick={() => void signOut()}>
            {t('console.signOut')}
          </Button>
        </div>
      </header>
      <div className="body">
        <ConsoleNav />
        <main className="area" data-scroll-restoration-id="main">
          <Outlet />
        </main>
      </div>
      <Toasts />
    </div>
  );
}
